import { Box, Callout } from '@radix-ui/themes'

import { fechaIsoToYYYY_MM_DD, formatDate } from '../utils/utils'
import { DocStateSpecial } from '../enums/DocStates'
import DocToHeader from '../interfaces/DocInactive'

export const DocStatusHeader = ({ docName, state }: { docName: string; state: DocToHeader }) => {
  let header = ''
  let header2a = ''
  let header2b = ''
  let header3a = ''
  let header3b = ''
  let action = ''
  let by = ''
  let article = 'Esta'

  switch (state.state) {
    case DocStateSpecial.Nulo:
      action = 'fue anulada'
      by = 'Anulada por:'
      break

    case DocStateSpecial.Archivado:
      action = 'fue archivada'
      by = 'Archivada por:'
      break

    case DocStateSpecial.Expirado:
      action = 'expiró'
      break
    case DocStateSpecial.Aprobado:
      action = 'fue aprobada'
      by = 'Por:'
      break
    case DocStateSpecial.Desactivado:
      action = 'fue desactivado'
      article = 'Este'
      by = 'Por:'
      break
    case DocStateSpecial.Descartado:
      action = 'fue descartado'
      article = 'Este'
      by = 'Por:'
      break
  }

  if (action.length > 0) {
    header = `${article} ${docName} ${action} el ${formatDate(fechaIsoToYYYY_MM_DD(state.date))}.`

    if (state.cause) {
      header2a = `Motivo:`
      header2b = `${state.cause}`
    }

    if (state.by) {
      header3a = by
      header3b = `${state.by}`
    }
    // }
  } else {
    return <></>
  }

  return (
    <Callout.Root mb="4" className="print:hidden">
      <Box>
        <div>{header}</div>
        <div className="flex">
          <div>{header2a}</div>
          <div className="ml-4">{header2b}</div>
        </div>
        <div className="flex">
          <div>{header3a}</div>
          <div className="ml-4">{header3b}</div>
        </div>
      </Box>
    </Callout.Root>
  )
}
export const DocStatusHeaderEx: React.FC<{
  title: string
  date?: string
  cause?: string
  by?: string
}> = ({ title, date, cause, by }) => {
  let header = ''
  let header2a = ''
  let header2b = ''
  let header3a = ''
  let header3b = ''

  if (title.length > 0) {
    header = `${title} el ${formatDate(fechaIsoToYYYY_MM_DD(date))}.`

    if (cause) {
      header2a = `Motivo:`
      header2b = `${cause}`
    }

    if (by) {
      header3a = 'Por:'
      header3b = `${by}`
    }
    // }
  } else {
    return <></>
  }

  return (
    <div className="w-full border-8 border-orange-200 border-l-orange-600 pl-1 mb-2 print:hidden">
      <div>{header}</div>
      <div className="flex">
        <div>{header2a}</div>
        <div className="ml-4">{header2b}</div>
      </div>
      <div className="flex">
        <div>{header3a}</div>
        <div className="ml-4">{header3b}</div>
      </div>
    </div>
  )
}
